import { useState } from "react";
import { useApp } from "../store.jsx";
import { fmtMonth } from "../calc.js";

// Compact CRUD for external gates belonging to a single department.
export default function GatesEditor({ dept }) {
  const { milestones, patchMilestone, addMilestone, removeMilestone } = useApp();
  const [adding, setAdding] = useState(false);
  const [newLabel, setNewLabel] = useState("");
  const [newMonth, setNewMonth] = useState("0");

  const gates = (milestones || [])
    .filter(m => m.deptShort === dept)
    .sort((a,b) => (a.sortOrder - b.sortOrder) || (a.month - b.month));

  async function onAdd(e) {
    e.preventDefault();
    const month = Number(newMonth);
    if (!newLabel.trim() || !Number.isFinite(month)) return;
    await addMilestone({ deptShort: dept, label: newLabel.trim(), month });
    setNewLabel(""); setNewMonth("0"); setAdding(false);
  }

  return (
    <section className="brief gates-editor">
      <h2 style={{margin:0}}>External gates</h2>
      <p className="sub" style={{marginTop:6, marginBottom:14}}>
        Constraints from outside this team (sign-offs, dependency releases, etc.). Drag the
        diamonds in the Gantt to reschedule, or edit inline below. Tasks declare which gates
        block them via the "External gates" section in the task editor.
      </p>

      {gates.length === 0 && (
        <div className="sub" style={{marginBottom:10}}>No gates yet for {dept}.</div>
      )}

      <table className="gates">
        <tbody>
          {gates.map(g => (
            <tr key={g.id}>
              <td>
                <span className="diamond"/>
              </td>
              <td className="title">
                <input type="text" value={g.label}
                       onChange={e => patchMilestone(g.id, { label: e.target.value })}/>
              </td>
              <td className="num">
                <input type="number" step="0.5" min="0" max="20"
                       value={g.month}
                       onChange={e => patchMilestone(g.id, { month: Number(e.target.value) })}/>
                <span className="sub" style={{marginLeft:6}}>{fmtMonth(g.month)}</span>
              </td>
              <td className="num">
                <button className="btn danger" onClick={() => removeMilestone(g.id)}>Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {adding ? (
        <form className="gates-add" onSubmit={onAdd}>
          <input type="text" placeholder="Label (e.g. Legal sign-off)" autoFocus
                 value={newLabel} onChange={e => setNewLabel(e.target.value)} />
          <input type="number" step="0.5" min="0" max="20" placeholder="Month (0–20)"
                 value={newMonth} onChange={e => setNewMonth(e.target.value)} />
          <button className="btn primary" type="submit">Add</button>
          <button className="btn" type="button" onClick={() => setAdding(false)}>Cancel</button>
        </form>
      ) : (
        <button className="btn" onClick={() => setAdding(true)} style={{marginTop:10}}>+ Add gate</button>
      )}
    </section>
  );
}
